<div class="frac-home-sandi-status">
  <sa-lmo-frac-home-card *ngIf="frac" localStorageKey="home__sandi_status">
    <header class="my-1 py-2">
      <img src="/assets/icons/sandi-wave.svg" alt="SANDi" />
      <span class="text-xl font-medium">Status</span>
    </header>
    <main class="grid divide-x divide-gray-400 gap-2">
      <div class="flex flex-row gap-2">
        <section class="info-panel">
          <div class="status" [class.warn]="timeToNpt !== '14h+'">{{ timeToNpt | minutesToHuman }}</div>
          <div class="name">Until NPT</div>
        </section>

        <section class="info-panel">
          <div class="status" [class.warn]="timeToNptNoPending !== '14h+'">
            {{ timeToNptNoPending | minutesToHuman }}
          </div>
          <div class="name">Excluding Pending Orders</div>
        </section>
      </div>

      <div class="flex flex-row gap-2">
        <section class="info-panel pl-2">
          <div class="status">
            {{ pendingCount$ | async }}
          </div>
          <div class="name">Pending Orders</div>
        </section>

        <section class="info-panel">
          <div class="status">
            {{ inProgressCount$ | async }}
          </div>
          <div class="name">In Progress Orders</div>
        </section>
      </div>

      <div class="flex flex-row gap-2">
        <section class="info-panel pl-2">
          <div class="status">
            {{ frac.currentStage }}
          </div>
          <div class="name">Current Stage</div>
        </section>

        <section class="info-panel">
          <div class="status">
            {{ frac.totalStages }}
          </div>
          <div class="name">Total Stages</div>
        </section>
      </div>
    </main>
  </sa-lmo-frac-home-card>
</div>
